import Cookies from 'js-cookie'

const user = {
  state: {
    // 国际化
    language: Cookies.get('language') || 'zh',
    screenData: null,
    alarmRefresh: 0, // 报警列表刷新
    urgeList: 0, // 督促报警列表刷新
    gasAlarm: 0 // 有毒有害气体预警监控刷新
  },
  mutations: {
    SET_LANGUAGE: (state, language) => {
      state.language = language
      Cookies.set('language', language)
    },
    // 消息通知 推送
    SET_SCREENDATA: (state, screenData) => {
      state.screenData = screenData
    },
    // 推送更新报警信息(刷新所有报警相关数据)
    SET_ALARMREFRESH: (state, alarmRefresh) => {
      state.alarmRefresh += alarmRefresh
    },
    // 推送更新（有督促按钮的报警列表）
    SET_URGELIST: (state, urgeList) => {
      state.urgeList += urgeList
    },
    // 推送更新（有毒有害气体预警监控刷新）
    SET_GASALARM: (state, gasAlarm) => {
      state.gasAlarm += gasAlarm
    }
  },
  actions: {
    setLanguage ({ commit }, language) {
      commit('SET_LANGUAGE', language)
    },
    // 推送内容
    setScreenData ({ commit }, screenData) {
      commit('SET_SCREENDATA', screenData)
    },
    // 推送更新报警信息
    setAlarmRefresh ({ commit }, alarmRefresh) {
      commit('SET_ALARMREFRESH', alarmRefresh)
    },
    // 推送更新（有督促按钮的报警列表）
    setUrgeList ({ commit }, urgeList) {
      commit('SET_URGELIST', urgeList)
    },
    // 推送更新（有毒有害气体预警监控刷新）
    setGasAlarm ({ commit }, gasAlarm) {
      commit('SET_GASALARM', gasAlarm)
    }
  }
}

export default user
